export * from "./DetailViewPage";
